import { Step } from "react-joyride";

export const tourStepsQuizShow = (): Step[] => {
  const steps: Step[] = [
    {
      target: "h1.mb-8",
      content:
        "Quiz Show puts the question on the class screen. Students answer on their phones with a room code.",
      disableBeacon: true,
    },
    {
      target: ".game-instructions",
      content:
        "Use sample questions, a collection, or questions you already saved in Multiple Choice.",
    },
    {
      target: ".question-source",
      content:
        "Collection mode shows an item on the big screen and four name choices on phones.",
    },
    {
      target: ".start-button",
      content:
        "Create Room gives you a code. Share the join link, wait for names to appear, then press Start.",
    },
  ];

  return steps;
};
